import styles from "./EvaluationReport.module.less";
import CommonNavBar from "views/components/CommonNavBar";
import { useNavigate, useLocation } from "react-router-dom";
import { postSubmitAnswerV2, getAppToken, getImgRequest } from "api/lesson";
import { useState, useEffect, useRef } from "react";
import { Toast } from "react-vant";
import html2canvas from "html2canvas";
import axios from "axios";
import DSBridge from "dsbridge";
const levelObj = {
  预备级: "content-level-box--1",
  入门级: "content-level-box--2",
  初级: "content-level-box--3",
  中低级: "content-level-box--4",
  中高级: "content-level-box--5",
  高级: "content-level-box--6",
};
const EvaluationReport = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [reportData, setReportData] = useState({});
  const toastRef = useRef(null);
  const picRef = useRef(null);
  const getBase64 = async (url) => {
    try {
      const response = await axios.get(url, {
        timeout: 30000,
        responseType: "blob",
      });
      const blob = response.data;
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = () => reject(new Error("读取 Blob 失败"));
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error("获取 Base64 失败:", error);
      throw error;
    }
  };
  const getData = async () => {
    toastRef.current = Toast.loading({
      message: "正在获取入门测试报告中...",
      forbidClick: true,
      duration: 0,
    });
    const res = await postSubmitAnswerV2({ score: queryParams.get("score") });
    if (res.code === 200) {
      if (
        Array.isArray(res.data["学习规划模块"]) &&
        res.data["学习规划模块"].length > 0
      ) {
        for (const item of res.data["学习规划模块"]) {
          try {
            const imgBase = await getBase64(item.cover);
            item.cover = imgBase;
          } catch (error) {
            item.cover = null;
            console.log(error);
          }
        }
        res.data["学习规划模块"] = res.data["学习规划模块"].filter(
          (i) => i.cover
        );
      }
      setReportData(res.data);
    }
    toastRef.current.clear();
  };

  function _utf8_encode(string) {
    string = string.replace(/\r\n/g, "\n");
    var utftext = "";
    for (var n = 0; n < string.length; n++) {
      var c = string.charCodeAt(n);
      if (c < 128) {
        utftext += String.fromCharCode(c);
      } else if (c > 127 && c < 2048) {
        utftext += String.fromCharCode((c >> 6) | 192);
        utftext += String.fromCharCode((c & 63) | 128);
      } else {
        utftext += String.fromCharCode((c >> 12) | 224);
        utftext += String.fromCharCode(((c >> 6) & 63) | 128);
        utftext += String.fromCharCode((c & 63) | 128);
      }
    }
    return utftext;
  }
  function baseCode64(input) {
    var _keyStr =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    var output = "";
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0;
    input = _utf8_encode(input);
    while (i < input.length) {
      chr1 = input.charCodeAt(i++);
      chr2 = input.charCodeAt(i++);
      chr3 = input.charCodeAt(i++);
      enc1 = chr1 >> 2;
      enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
      enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
      enc4 = chr3 & 63;
      if (isNaN(chr2)) {
        enc3 = enc4 = 64;
      } else if (isNaN(chr3)) {
        enc4 = 64;
      }
      output =
        output +
        _keyStr.charAt(enc1) +
        _keyStr.charAt(enc2) +
        _keyStr.charAt(enc3) +
        _keyStr.charAt(enc4);
    }
    return output;
  }
  async function handlePic(type) {
    if (!picRef.current) {
      toastRef.current = Toast.loading({
        message: "正在处理图片...",
        forbidClick: true,
        duration: 0,
      });
      const element = document.getElementById("back-box");
      const options = {
        useCORS: true,
        scale: 2,
        logging: false,
        backgroundColor: "#ffffff",
        allowTaint: true,
      };
      try {
        const canvas = await html2canvas(element, options);
        const dataUrl = canvas.toDataURL("image/png");
        const dataBase64 = dataUrl.split(",")[1];
        const tokenRes = await getAppToken();
        if (tokenRes.code === 200) {
          try {
            const phone = JSON.parse(
              localStorage.getItem("userInfo")
            ).phone_number;
            const uploadUrl = `https://up-z1.qiniup.com/putb64/-1/key/${baseCode64(
              `utalkrc/${phone}/${new Date().getTime()}`
            )}`;
            const qiniuRes = await axios.post(uploadUrl, dataBase64, {
              timeout: 30000,
              headers: {
                "Content-Type": "application/octet-stream",
                Authorization: `UpToken ${tokenRes.data}`,
              },
            });
            picRef.current = `https://cdn03.myaitalk.vip/${qiniuRes.data.key}`;
          } catch (e) {
            toastRef.current.clear();
            return Toast.info("截取图片失败，请重试");
          }
        }
        toastRef.current.clear();
      } catch (error) {
        toastRef.current.clear();
        console.log(error);
        if (type === 1) {
          return Toast.info("检查网络连接或稍后重试");
        }
        if (type === 2) {
          return Toast.info("检查系统分享功能是否正常或稍后再试");
        }
      }
    }
    if (type === 1) {
      Toast.info("正在保存图片，请稍后");
      DSBridge.call(
        "share.saveImage",
        {
          url: picRef.current,
        },
        (back) => {
          console.log(back);
        }
      );
    }
    if (type === 2) {
      Toast.info("正在分享，请稍后");
      DSBridge.call(
        "share.shareInfo",
        {
          type: "image",
          scene: 0,
          title: "入门测试报告",
          image: picRef.current,
        },
        (back) => {
          console.log(back);
        }
      );
    }
  }
  useEffect(() => {
    getData();
  }, []);
  return (
    <div className={styles["evaluation-report-container"]}>
      <CommonNavBar
        backgroundColor={"#ffffff"}
        title="入门测试报告"
        onClickBack={() => {
          if (queryParams.get("isHome")) {
            navigate(`/main/home`, { replace: true });
          } else {
            navigate(-1);
          }
        }}
        rightContent={
          Object.keys(reportData).length > 0 ? (
            <>
              <div className={styles["right-buttons"]}>
                <img
                  className={styles["right-buttons-item"]}
                  src={require("@/images/evaluation-report/download.png")}
                  onClick={() => handlePic(1)}
                />
                <img
                  className={styles["right-buttons-item"]}
                  src={require("@/images/evaluation-report/forward.png")}
                  onClick={() => handlePic(2)}
                />
              </div>
            </>
          ) : null
        }
      />
      <div className={styles["back-container"]} id="back-box">
        {Object.keys(reportData).length > 0 ? (
          <>
            <div className={styles[("center-box", "top-box")]}>
              <div className={styles["center-box-title"]}>·测评等级·</div>
              <div className={styles["center-box-content"]}>
                <div className={styles["content-desc"]}>
                  <img
                    className={styles["desc-img"]}
                    src={require("@/images/evaluation-report/cup.png")}
                  />
                  <div className={styles["desc-title"]}>
                    {`${reportData["建议学习难度"] || ""}${
                      reportData["Level"]
                        ? "（" + reportData["Level"] + "）"
                        : ""
                    }`}
                  </div>
                  <div className={styles["desc-text"]}>
                    {"继续保持，你做得很棒！"}
                  </div>
                </div>
              </div>
            </div>
            <div className={styles["center-box"]}>
              <div className={styles["center-box-title"]}>·等级说明·</div>
              <div className={styles["center-box-content"]}>
                <div className={styles["content-text"]}>
                  {reportData["报告评语"] || ""}
                </div>
              </div>
            </div>
            <div className={styles["center-box"]}>
              <div className={styles["center-box-title"]}>·级别对标·</div>
              <div className={styles["center-box-content"]}>
                <div
                  className={`${styles["content-level-box"]} ${
                    levelObj[reportData["建议学习难度"]]
                      ? styles[levelObj[reportData["建议学习难度"]]]
                      : ""
                  }`}
                >
                  <div className={styles["content-level-box-text"]}>
                    当前位置
                  </div>
                  <img
                    className={styles["content-level-box-ubao"]}
                    src={require("@/images/evaluation-report/level_3.png")}
                  />
                  <img
                    className={styles["content-level-box-arrow"]}
                    src={require("@/images/evaluation-report/level_2.png")}
                  />
                </div>
                <img
                  className={styles["content-level-back"]}
                  src={require("@/images/evaluation-report/level_1.png")}
                />
              </div>
            </div>
            {Array.isArray(reportData["学习规划模块"]) &&
            reportData["学习规划模块"].length > 0 ? (
              <div className={styles["center-box"]}>
                <div className={styles["center-box-title"]}>·学习规划·</div>
                <div className={styles["center-box-content"]}>
                  <div className={styles["book-list"]}>
                    {reportData["学习规划模块"].map((item, index) => (
                      <div
                        className={styles["book-list-item"]}
                        key={`book-list-item-${index}`}
                      >
                        <img className={styles["item-pic"]} src={item.cover} />
                        <div className={styles["item-text"]}>
                          {item.title || ""}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ) : null}
            {/* <div className={styles["bottom-ubao"]}>
              <div className={styles["bottom-ubao-text"]}>
                请联系您的助教老师进行测评分析！
              </div>
            </div> */}
          </>
        ) : null}
      </div>
    </div>
  );
};
export default EvaluationReport;
